import { types } from '@/api/amplify/graphql/types/widgets';
import { Logger } from '@/helpers/log';
import { ns } from '@/helpers/store';
import { DASHBOARD_SCOPE } from '@/store/types/getters';
import { ACCOUNT, DASHBOARDS, FILTERS } from '@/store/types/namespaces';
import { apolloClient } from '../../../api/apollo';
import { PropertiesDocument } from '../../../api/apollo/generated/sdk';
import { propertiesToListableProperties } from '../../../api/legacy/useListableProperties';
import { linkAggregate, linkAlarms, linkCohort, linkDevice, linkEvent, linkFloorplan, linkList, linkMap, linkProperty, linkStatus, linkWorkflow } from './widgets';

const logger = new Logger('store:amplify:widgets/dashboardWidgets');

const linkers = {
  [types.cohort]: linkCohort,
  [types.aggregate]: linkAggregate,
  [types.event]: linkEvent,
  [types.list]: linkList,
  [types.map]: linkMap,
  [types.property]: linkProperty,
  [types.status]: linkStatus,
  [types.floorplan]: linkFloorplan,
  [types.device]: linkDevice,
  [types.workflow]: linkWorkflow,
  [types.alarms]: linkAlarms,
};

export default function dashboardWidgets(state, getters, rootState, rootGetters) {
  const { widgets } = state;
  // HACK: relies on the fact that properties will almost _always_ be cached.
  // really linking and unlink should be done at the api level (if at all)
  const accountId = rootState[ACCOUNT].id;
  const cachedProperties = apolloClient.readQuery({
    query: PropertiesDocument,
    variables: { accountId },
  });
  if (!cachedProperties) console.warn('no properties cached');
  const properties = propertiesToListableProperties(cachedProperties);

  const { filters } = rootState[FILTERS];
  const scope = rootGetters[ns(DASHBOARDS, DASHBOARD_SCOPE)];
  const kpis = rootState.kpis.kpis
    .map(({ $id, ...rest }) => ({ ...rest, $id, id: $id })); // TODO: namespace
  const resources = { properties, filters, kpis };
  const linked = widgets.reduce((l, w) => {
    const { type, id } = w;
    if (l[id]) {
      logger.error('ignored widget with duplicated id', w, l[id]);
      return l;
    }
    const linker = linkers[type];
    if (!linker) {
      logger.error('ignored widget of unknown type', w);
      return l;
    }
    const widget = linker(w, resources, scope);
    return { ...l, [id]: widget };
  }, {});
  return linked;
}
